import bootstrapdatepicker from 'angular-ui-bootstrap/src/datepickerPopup';
import { dateRequiredDirective } from './date-required.directive';
import { dateBeforeDirective } from './date-before.directive';
import { datepickerComponent } from './datepicker.component';
import './datepicker.scss';

export const datepicker = angular
	.module('common.libs.datepicker', [
		bootstrapdatepicker
	])
	.directive('dateRequired', dateRequiredDirective)
	.directive('dateBefore', dateBeforeDirective)
	.component('datepicker', datepickerComponent)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/datepicker/datepicker.module.js